import { response } from 'express';
import _ from 'lodash';
import {
    Applications3, Groups3, ImportCSVRequest, IUserCreationRequest,
    IUserUpdateRequest, MailTypes, Options,
    Privileges3, User, UserBulkActivateRequest,
    UserBulkAssignApplicationRequest,
    UserBulkAssignGroupRequest, UserBulkAssignWorkspaceRequest, UserBulkDeactivateRequest, UserBulkDeleteRequest,
    UserBulkMailRequest, UserCollection, UserCreationRequest, UsersClient, UserSynchronizeRequest, UserUpdateRequest, UserCreateApplicationKeyRequest, UserBulkUpdateAD
} from '../clients/aasServerClient.generated';
import { TableFilters, TableSorting } from '../stores/tables/state';

export  async function getUsersId(searchString: string , 
    filters: TableFilters) : Promise<string []>
{ 
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    let ret: string [] = [] ;
    let users :  UserCollection =  await   client.getUsersIds(
        false, undefined,
        undefined, undefined, undefined,
        filters.w?.join(';'), filters.a?.join(';'), filters.g?.join(';'),
        searchString
    );         
    users.items.forEach(element => {ret.push( element.id)});
    return ret;
}

export function getUsersWoFilters(
    limit: number, start: number,
    sorting: TableSorting
): Promise<UserCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getUsers(
        false, true,
        limit, start, ordering,
        undefined, undefined, undefined,
        undefined
    );
}


export function getUsers(
    limit: number, start: number,
    sorting: TableSorting,
    filters: TableFilters,
    searchString?: string
): Promise<UserCollection> {
    const ordering = `${sorting.column} ${sorting.order}`;
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getUsers(
        false, true,
        limit, start, ordering,
        filters.w?.join(';'), filters.a?.join(';'), filters.g?.join(';'),
        searchString
    );
}

export function getAllUsers(): Promise<UserCollection> {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getUsers(
        true, undefined,
        undefined, undefined, undefined,
        undefined, undefined, undefined,
        undefined
    );
}

export function getUser(id: string): Promise<User> {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getUser(id);
}

export function updateUser(
    user: Partial<User>,
    workspace?: string,
    apps?: Array<{ id: string, value: boolean }>,
    groups?: Array<{ id: string, value: boolean }>,
    privileges?: Array<{ name: string, value: boolean }>
): Promise<User> {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    const data: IUserUpdateRequest =
        _.assign(user, {
            applications: apps ? apps.map((app) => new Applications3(app)) : undefined,
            groups: groups ? groups.map((group) => new Groups3(group)) : undefined,
            privileges: privileges ? privileges.map((p) => new Privileges3(p)) : undefined,
            workspace,
        }) as unknown as IUserUpdateRequest;
    return client.updateUser(user.id!, new UserUpdateRequest(data));
}

export function createUser(
    mail: boolean | undefined,
    user: Partial<User>,
    workspace?: string,
    apps?: Array<{ id: string, value: boolean }>,
    groups?: Array<{ id: string, value: boolean }>,
    privileges?: Array<{ name: string, value: boolean }>
): Promise<User> {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    const data: IUserCreationRequest =
        _.assign(user, {
            applications: apps ? apps.map((app) => new Applications3(app)) : undefined,
            groups: groups ? groups.map((group) => new Groups3(group)) : undefined,
            mailUser: mail,
            privileges: privileges ? privileges.map((p) => new Privileges3(p)) : undefined,
            workspace,
        }) as unknown as IUserCreationRequest;
    return client.createUser(new UserCreationRequest(data));
}

export function activateUsers(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkActivateUsers(new UserBulkActivateRequest({ ids }));
}

export function updateUsers(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkUpdateADUsers(new UserBulkUpdateAD({ ids }));
}

export function deactivateUsers(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeactivateUsers(new UserBulkDeactivateRequest({ ids }));
}

export function deleteUsers(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkDeleteUsers(new UserBulkDeleteRequest({ ids }));
}

export function sendNewUserMail(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkMailUsers(new UserBulkMailRequest({ ids, mailType: MailTypes.NewUser }));
}

export function sendResetPasswordMail(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkMailUsers(new UserBulkMailRequest({ ids, mailType: MailTypes.ResetPassword }));
}

export function sendVerifyEmailMail(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkMailUsers(new UserBulkMailRequest({ ids, mailType: MailTypes.VerifyEmail }));
}

export function sendMigratePasswordMail(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkMailUsers(new UserBulkMailRequest({ ids, mailType: MailTypes.MigratePassword }));
}

export function sendMigrateAccountMail(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkMailUsers(new UserBulkMailRequest({ ids, mailType: MailTypes.MigrateAccount }));
}

export function synchronize(ids: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkSynchronize(new UserSynchronizeRequest({ ids }));
}

export function assignUsersWorkspace(userIds: string[], workspaceId: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignWorkspaceAll(
        new UserBulkAssignWorkspaceRequest({ users: userIds, workspace: workspaceId })
    );
}

export function assignUsersApplications(userIds: string[], appIds: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignApplicationsAll(
        new UserBulkAssignApplicationRequest({ users: userIds, applications: appIds })
    );
}

export function createApplicationKey(userIds: string[], appId: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.createApplicationKey(
        new UserCreateApplicationKeyRequest({ users: userIds, application: appId })
    );
}

export function getApplicationKeys(userId: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.getApplicationKeys(userId);
}

export function deleteApplicationKey(userId: string, appId: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.deleteApplicationKey(
        userId, { application: appId }
    );
}

export function assignUsersGroups(userIds: string[], groupIds: string[]) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.bulkAssignGroupsAll(
        new UserBulkAssignGroupRequest({ users: userIds, groups: groupIds })
    );
}

export function csvImport(csv: string, emailUsers: boolean, workspaceId: string) {
    const client = new UsersClient(process.env.PUBLIC_URL + '/api');
    return client.importCSV(new ImportCSVRequest({
        csv,
        options: new Options({
            emailUsers,
            workspaceId,
        })
    }));
}